export default {
  DotcomHeaderMobileWithGlobalNav__BUTTON_GROUP_ARIA_NEXT: "Next",
  DotcomHeaderMobileWithGlobalNav__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
